// removed by extract-text-webpack-plugin
module.exports = {"RefundType":"_Belya"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Airline/AirlineRefundable/AirlineRefundable.scss
// module id = 511
// module chunks = 0